import React, { useEffect, useState } from "react";
import PersonalInformation from "./components/personalInfoForm";
import {
  COLLECTINFOVIEW,
  SUCCESSVIEW,
  SUGGESTAPOSTVIEW,
} from "./utils/constant";
import SuggestAPost from "./components/suggestAPost";
import SuccessView from "./components/successPage";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import "./index.css";
import { useDispatch } from "react-redux";
import { updateCurrentView } from "../../redux/slices/externalContent/externalContent";
import {RECAPTCHA_PUBLIC_KEY} from "../../config-global";

const RECAPTCHA_SITE_KEY = "6LfV38IgAAAAAOdesgwnW7iA5EEzU3Vd3coVtH2f";
const ExternalContent = ({ sortableListRef }) => {
  const dispatch = useDispatch();
  const [currentView, setCurrentView] = useState(COLLECTINFOVIEW);

  useEffect(() => {
    dispatch(
      updateCurrentView({
        view: currentView,
      })
    );
  }, [currentView]);

  return (
    <div className="h-100 w-100 externalContentCollect">
      {currentView === COLLECTINFOVIEW ? (
        <div
          style={{ overflowY: "auto" }}
          className="h-100 w-100 d-flex align-items-start justify-content-center position-relative py-4 py-md-5 px-3"
        >
          <PersonalInformation
            currentView={currentView}
            setCurrentView={setCurrentView}
          />
        </div>
      ) : currentView === SUGGESTAPOSTVIEW ? (
        <div
          style={{ overflowY: "auto" }}
          className="h-100 w-100 d-flex flex-column align-items-start justify-content-start position-relative py-4 py-md-5 px-3"
        >
          <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
            <SuggestAPost
              currentView={currentView}
              setCurrentView={setCurrentView}
              sortableListRef={sortableListRef}
            />
          </GoogleReCaptchaProvider>
        </div>
      ) : currentView === SUCCESSVIEW ? (
        <div
          style={{ overflowY: "auto" }}
          className="h-100 w-100 d-flex align-items-start justify-content-center py-4 py-md-5 px-3"
        >
          <SuccessView
            currentView={currentView}
            setCurrentView={setCurrentView}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default ExternalContent;
